export enum UploadType {
  skills = "skills",
  topics = "topics",
  questions = "questions",
}
